import { Component, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { NotificationResponse } from '@classes/notification/notification-response';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { NotificationsService } from '@services/notifications.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  notifications: NotificationResponse[] = [];
  isLoading: boolean;
  filterValue = null;
  sortValue: string;
  pagination: Pagination;


  constructor(
    private notificationsSrv: NotificationsService
  ) { }

  ngOnInit() {

    this.initSubscriptions();
  }

  clearOne(index: number) {
    this.notificationsSrv.removeOne(index);
  }

  onClear(): void {
    this.notifications = [];
    this.notificationsSrv.clearNotifications();
  }

  private initSubscriptions(): void {

    this.subscription.add(
      this.notificationsSrv.notificationsSubject
        .subscribe(notifications => {
          this.notifications = notifications;
          localStorage.setItem('notifications', JSON.stringify(this.notifications));
        })
    );

    this.notificationsSrv.checkLocalStorage();

    this.subscription.add(
      this.notificationsSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
  }
}
